'use client';

import { AccountEmails as Section } from '../../components/UserProfile/AccountSections';
import { createSection } from '../createSection';

export const UserProfileEmailSection = createSection('UserProfileEmailSection', Section);
